import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TariffOverride } from 'entities/tariff/api/contracts';
import { FixedPricePerUnitsStyled, PricePerUnitsContainerStyled } from './FixedPricePerUnits.styles';

interface Props {
	override: TariffOverride;
	pricePerUnit: number;
}

export const FixedPricePerUnits: FC<Props> = ({ override, pricePerUnit }) => {
	const { t } = useTranslation();

	return (
		<>
			<PricePerUnitsContainerStyled>
				<FixedPricePerUnitsStyled>
					{t(`Marketplace_Price_Per_Multiple_Units`, {
						start: 1,
						end: override.toNumberOfUnits ?? ``,
					})}
				</FixedPricePerUnitsStyled>
				<FixedPricePerUnitsStyled>{`${override.price.toLocaleString()} ₽ / ${t(
					`Marketplace_Per_Month`,
				)}`}</FixedPricePerUnitsStyled>
			</PricePerUnitsContainerStyled>
			<PricePerUnitsContainerStyled>
				<FixedPricePerUnitsStyled>
					{override.toNumberOfUnits
						? t(`Marketplace_Price_Per_Multiple_Units_Infinite`, { end: override.toNumberOfUnits + 1 })
						: ``}
				</FixedPricePerUnitsStyled>
				<FixedPricePerUnitsStyled>{`+ ${pricePerUnit.toLocaleString()} ₽ ${t(
					`Marketplace_Per_Units_Per_Month`,
				)}`}</FixedPricePerUnitsStyled>
			</PricePerUnitsContainerStyled>
		</>
	);
};
